import { css } from '@emotion/core';
import tinycolor from 'tinycolor2';

import { colours } from './variables';

export const accentLink = css`
  color: ${colours.primary};
  transition: color 0.25s ease-in-out;

  &:hover,
  &:focus {
    color: ${tinycolor(colours.primary).darken(8).toHexString()};
  }

  &:active {
    color: ${tinycolor(colours.primary).darken(14).toHexString()};
  }
`;
